import styled from "@emotion/styled";

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.background};
  ${({ addStyles }) => addStyles};
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.background};
  ${({ addStyles }) => addStyles};
`;
